import Vue from 'vue'


Vue.filter('replace', function (value, from, to) {
    return value.replace(from, to)
})